<template>
  <BarGenerator :data="chartData" :options="options" />
</template>

<script>
import { Bar as BarGenerator } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
  name: "BudgetIncomeExpenseBarChart",
  components: { BarGenerator },
  props: {
    budgetIncome: { type: Number, required: true },
    actualIncome: { type: Number, required: true },
    budgetExpense: { type: Number, required: true },
    actualExpense: { type: Number, required: true },
  },
  computed: {
    chartData() {
      return {
        labels: ["Income", "Expense"],
        datasets: [
          {
            label: "Budget",
            backgroundColor: "#018673",
            data: [this.budgetIncome, this.budgetExpense],
          },
          {
            label: "Actual",
            backgroundColor: "#1d4ed8",
            data: [this.actualIncome, this.actualExpense],
          },
        ],
      };
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: true },
          tooltip: { enabled: true },
        },
        scales: {
          y: { beginAtZero: true },
        },
      };
    },
  },
};
</script>

